module.exports = __webpack_public_path__ + "img/保健药品.3fb579ce.png";